/**
 * @file RolesTable.jsx
 * @description Roles Table component for displaying and managing roles.
 * @component RolesTable
 * @exports RolesTable - Main component for displaying and managing roles.
 */

import React from "react";
import Table from "@mui/material/Table";
import { Edit } from "@mui/icons-material";
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import IconButton from "@mui/material/IconButton";
import TableSortLabel from "@mui/material/TableSortLabel";
import TableContainer from "@mui/material/TableContainer";
import LinearProgress from '@mui/material/LinearProgress';
import TablePagination from "@mui/material/TablePagination";
import { SIZES, SORT_ORDERS, ALIGN, HTML_TAGS } from "../../../common/constants/commonConstants.js";
import { ROLE_TABLE_COLUMN_KEYS, ROLE_MESSAGES } from "../../../common/constants/adminModule/roleConstants.js";

const RolesTable = ({
    page,
    order,
    setPage,
    orderBy,
    roles,
    rowsPerPage,
    columns,
    isRolesLoading,
    onEdit,
    setRowsPerPage,
    handleRequestSort,
    filteredRolesLength
}) => {
    return (
        <>
            <TableContainer sx={{ mt: 2 }}>
                <Table size={SIZES.SMALL}>
                    <TableHead>
                        <TableRow>
                            {columns.map((column) => (
                                <TableCell
                                    key={column.id}
                                    sortDirection={orderBy === column.id ? order : false}
                                    sx={{
                                        width:
                                            column.id === ROLE_TABLE_COLUMN_KEYS.ACTIONS ? 50 :
                                                column.id === ROLE_TABLE_COLUMN_KEYS.ID ? 50 :
                                                    column.id === ROLE_TABLE_COLUMN_KEYS.ROLE_NAME ? 200 : 200,
                                    }}
                                >
                                    {column.isSortable ? (
                                        <TableSortLabel
                                            active={orderBy === column.id}
                                            direction={orderBy === column.id ? order : SORT_ORDERS.ASCENDING}
                                            onClick={() =>
                                                handleRequestSort(column.id)
                                            }
                                        >
                                            {column.label}
                                        </TableSortLabel>
                                    ) : column.label}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {isRolesLoading ? (
                            <TableRow>
                                <TableCell colSpan={columns.length} align={ALIGN.CENTER} >
                                    <LinearProgress />
                                </TableCell>
                            </TableRow>
                        ) : roles.length > 0 ? roles.map((role) => (
                            <TableRow hover tabIndex={-1} key={role.id}>
                                <TableCell>
                                    <IconButton onClick={() => onEdit(role)}>
                                        <Edit fontSize={SIZES.SMALL} />
                                    </IconButton>
                                </TableCell>
                                <TableCell>
                                    {role.id}
                                </TableCell>
                                <TableCell>
                                    {role.rolename}
                                </TableCell>
                                <TableCell>
                                    {new Date(role.createdate).toLocaleDateString('en-US')}
                                </TableCell>
                            </TableRow>
                        )) : (
                            <TableRow>
                                <TableCell colSpan={columns.length} align={ALIGN.CENTER}>
                                    {ROLE_MESSAGES.NO_ROLES}
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
                <TablePagination
                    page={page}
                    rowsPerPage={rowsPerPage}
                    component={HTML_TAGS.DIV}
                    count={filteredRolesLength}
                    rowsPerPageOptions={[10, 25, 50]}
                    onPageChange={(event, newPage) => setPage(newPage)}
                    onRowsPerPageChange={(event) => {
                        setPage(0);
                        setRowsPerPage(parseInt(event.target.value, 10));
                    }}
                />
            </TableContainer>
        </>
    )
};

export default RolesTable;